export default __webpack_public_path__ + "static/media/nokorijikan.b5ba33a3.svg";